import ModalTrigger from "components/modals/modal-trigger";
import { ModalBody } from "@evertrue/et-components";
import ModalHeaderWithActionsAndImage from "../ModalHeaderWithActionsAndImage";
import AIEmailTemplate from "./ai-email-template";
import Modal from "components/modals/modal";
import PropTypes from "prop-types";

const AIEmailTemplateModalTrigger = ({
  contact,
  emailPrompt,
  showEmailtemplate,
  setShowEmailTemplate,
  setShowContactModal,
}) => {

  const handleDoneButton = () => {
    setShowEmailTemplate(false);
  };

  /**
   * Timeout is set because hide func in modal.coffee takes time to hide
   */
  const handleBackButton = () => {
    setShowEmailTemplate(false);
    setTimeout(() => {
      setShowContactModal(true);
    }, [300]);
  };

  const renderEmailTemplateModal = () => {
    const title = emailPrompt.display_name;
    return (
      <Modal width={818} keepOpen>
        <ModalHeaderWithActionsAndImage
          title={title}
          submitLabel="Done"
          closeLabel="Back"
          imageSrc="/images/ai-email.png"
          closeModal={handleBackButton}
          onSubmit={handleDoneButton}
        />
        <ModalBody>
          <AIEmailTemplate title={title} contact={contact} promptKey={emailPrompt.key} />
        </ModalBody>
      </Modal>
    );
  };

  return (
    <>
      <ModalTrigger modal={renderEmailTemplateModal()} show={showEmailtemplate} title="AI generated email templates" />
    </>
  );  
};

AIEmailTemplateModalTrigger.propTypes = {
    contact: PropTypes.object.isRequired,
    emailPrompt: PropTypes.object.isRequired,
    showEmailtemplate: PropTypes.bool.isRequired,
    setShowEmailTemplate: PropTypes.func.isRequired,
    setShowContactModal: PropTypes.func.isRequired,
  };

export default AIEmailTemplateModalTrigger;
